import * as React from 'react';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Dispatch } from 'react-redux';
import { ITranslateProps } from 'models/common';
import { LoadingOverlayWrapper } from 'components/Loader';
import renderIcon from 'helpers/renderIcon';
import { browserHistory, Link, RouteComponentProps } from 'react-router';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { formatCurrency } from 'helpers/common';
import moment = require('moment');
import { IDiscountStrategy } from 'models/shop/discountStrategies';
import {
	addEditBatchDiscountStrategies,
	deleteDiscountStrategyGroup,
	getDiscountStrategies,
} from 'redux/modules/shop/discountStrategies';
import { ErrorSummary } from 'components';
import { DiscountTagType, renderDiscountTag } from '../SalesPromotions';
import { DropdownModal } from 'components/Common/DropdownModal';
import { actions as notifActions } from 'redux-notifications';
import { getShopServiceGroups } from 'redux/modules/shop/serviceGroups';
import { getBookingTemplatesByOffice } from 'redux/modules/shop/bookingtemplates';
import { groupBy } from '../Helpers';
import { IServicesList } from 'models/shop/shopBookingTemplates';
import { IServiceGroup } from 'models/shop/serviceGroups';
import { momentWithTimezone, sequentialWithBreak } from 'redux/modules/shop/helpers';

require('./style.scss');

interface IParams {
	shopId: string;
	promotionGroupId: string;
}

interface IOwnProps extends RouteComponentProps<IParams, {}> {}

interface IProps
	extends IOwnProps,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {}

interface IState {
	locations: string[];
	groupedBt?: {
		sgById: { [key: string]: IServiceGroup[] };
		sgByParent: { [key: string]: IServiceGroup[] };
		sgWithoutParentByCategory: { [key: string]: IServiceGroup[] };
		btByVariant: { [key: string]: IServicesList[] };
		byBySgByVp: { [key: string]: { [key: string]: IServicesList[] } };
	};
}
const mapStateToProps = (state: IStore) => ({
	shopCard: state.shopcard.shopcard,
	entireShopCard: state.shopcard,
	discountStrategies: state.discountStrategyReducer,
	serviceGroups: state.serviceGroups,
	shopBookingTemplates: state.shopBookingTemplates,
	domainValues: state.domainValues,
});

const formatDate = (date, timezone) => momentWithTimezone(timezone, date).format('LL');
const formatDateAndTime = (date) => moment(date).format('LL, LT');

const mapDispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	getShopCard: () => dispatch(getShopCard(ownProps.params.shopId, false, true)),
	getDiscountStrategies: (shopId) => dispatch(getDiscountStrategies(shopId)),
	addEditBatchDiscountStrategies: (discountStrategies, groupId) =>
		dispatch((dispatch, getState) =>
			addEditBatchDiscountStrategies(dispatch, getState, ownProps.params.shopId, discountStrategies, groupId),
		),
	deleteDiscountStrategyGroup: (groupId) =>
		dispatch((dispatch, getState) => deleteDiscountStrategyGroup(dispatch, getState, ownProps.params.shopId, groupId)),
	showNotification: (message: string, kind: string, dismissAfter = 3000) =>
		dispatch(notifActions.notifSend({ message, kind, dismissAfter })),
	getServiceGroupsByShop: () => dispatch(getShopServiceGroups(ownProps.params.shopId)),
	getBookingTemplatesByOffice: (officeId: string) =>
		dispatch(getBookingTemplatesByOffice(officeId, false, 'services', true)),
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewPromotionComponent extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			locations: [],
		};

		this.setGroupActive = this.setGroupActive.bind(this);
		this.deleteGroup = this.deleteGroup.bind(this);
		this.updateMemoData = this.updateMemoData.bind(this);
	}

	public componentDidMount(): void {
		if (
			(!this.props.shopCard && !this.props.entireShopCard.isFetching) ||
			this.props.shopCard?.id != this.props.params.shopId
		) {
			this.props.getShopCard();
		}

		if (
			!this.props.discountStrategies.groupedDiscountStrategies &&
			!this.props.discountStrategies.error &&
			!this.props.discountStrategies.isFetching &&
			this.props.params.shopId != this.props.discountStrategies.shopId
		) {
			this.props.getDiscountStrategies(this.props.params.shopId);
		}

		if (
			(!this.props.serviceGroups?.serviceGroups ||
				!this.props.serviceGroups.fetchedByShop ||
				this.props.serviceGroups?.serviceGroups?.[0]?.shopId != this.props.params.shopId) &&
			!this.props.serviceGroups.error &&
			!this.props.serviceGroups.isFetching
		) {
			this.props.getServiceGroupsByShop();
		}

		if (
			!this.props.shopBookingTemplates.error &&
			!this.props.shopBookingTemplates.isFetching &&
			this.props.shopCard?.offices?.length &&
			this.props.params.shopId == this.props.discountStrategies.shopId
		) {
			const discountGroup =
				this.props.discountStrategies?.groupedDiscountStrategies?.[this.props.params.promotionGroupId];
			const locations = new Set<string>();
			discountGroup?.forEach((discountStrat) => locations.add(discountStrat.officeId));

			const officeIds = Array.from(locations);
			sequentialWithBreak(officeIds.map((id) => () => this.props.getBookingTemplatesByOffice(id))).then(() =>
				this.updateMemoData(),
			);
		}

		this.updateMemoData();
	}

	componentDidUpdate(prevProps: Readonly<IProps>): void {
		if (
			prevProps?.shopCard?.id != this.props.shopCard?.id ||
			JSON.stringify(Object.keys(prevProps.discountStrategies.groupedDiscountStrategies || {})) !=
				JSON.stringify(Object.keys(this.props.discountStrategies.groupedDiscountStrategies || {})) ||
			prevProps.shopBookingTemplates?.services?.[0]?.shopId != this.props.shopBookingTemplates?.services?.[0]?.shopId ||
			prevProps.serviceGroups?.serviceGroups?.[0]?.shopId != this.props.serviceGroups?.serviceGroups?.[0]?.shopId ||
			prevProps.serviceGroups?.fetchedByShop != this.props.serviceGroups?.fetchedByShop
		) {
			this.updateMemoData();
		}

		if (
			prevProps?.shopCard?.id !== this.props.shopCard?.id ||
			prevProps.shopCard?.offices?.length != this.props.shopCard?.offices?.length ||
			this.props.discountStrategies?.shopId != prevProps.discountStrategies?.shopId ||
			this.props.discountStrategies?.isFetching != prevProps.discountStrategies?.isFetching
		) {
			const discountGroup =
				this.props.discountStrategies?.groupedDiscountStrategies?.[this.props.params.promotionGroupId];
			const locations = new Set<string>();
			discountGroup?.forEach((discountStrat) => locations.add(discountStrat.officeId));

			const officeIds = Array.from(locations);
			sequentialWithBreak(officeIds.map((id) => () => this.props.getBookingTemplatesByOffice(id))).then(() =>
				this.updateMemoData(),
			);
		}
	}

	private setGroupActive(groupId: string, status) {
		const discountGroup = this.props.discountStrategies?.groupedDiscountStrategies?.[groupId];
		if (discountGroup)
			this.props
				.addEditBatchDiscountStrategies(
					discountGroup.map((d) => ({ ...d, isActive: status })),
					groupId,
				)
				.then((newGroupId) => {
					if (newGroupId) browserHistory.replace(`/shop/${this.props.params.shopId}/view/promo/${newGroupId}`);
					else browserHistory.push(`/shop/${this.props.params.shopId}/edit/promo`);

					this.props.showNotification(this.props.t('Shop_Promotions_SavedSuccessfully'), 'success');
				})
				.catch((e) => {
					this.props.showNotification(e, 'error');
				});
	}

	private deleteGroup(groupId: string) {
		this.props
			.deleteDiscountStrategyGroup(groupId)
			.then(() => {
				this.props.showNotification(this.props.t('Shop_Promotions_SavedSuccessfully'), 'success');
				browserHistory.push(`/shop/${this.props.params.shopId}/edit/promo`);
			})
			.catch((e) => {
				this.props.showNotification(e, 'error');
			});
	}

	private updateMemoData() {
		const discountGroup =
			this.props.discountStrategies?.groupedDiscountStrategies?.[this.props.params.promotionGroupId];
		if (this.props.shopCard?.offices?.length && discountGroup) {
			const locations = new Set();
			discountGroup?.forEach((discountStrat) => locations.add(discountStrat.officeId));
			let locationNames = Array.from(locations.values()).filter((a) => !!a);
			locationNames = locationNames.map(
				(officeId) => this.props.shopCard?.offices?.find((office) => office.id == officeId)?.name,
			);

			const selectedBtIds = new Set();
			const selectedSgIds = new Set();
			const selectedServiceGroups = [];
			const selectedBt = [];
			if (this.props.shopBookingTemplates?.services?.length && this.props.serviceGroups?.serviceGroups?.length) {
				discountGroup.forEach((discountStrat) => {
					if (!selectedBtIds.has(discountStrat.bookingTemplateId)) {
						const bt = this.props.shopBookingTemplates.services.find((bt) => bt.id == discountStrat.bookingTemplateId);
						if (bt) {
							selectedBt.push(bt);
							selectedBtIds.add(discountStrat.bookingTemplateId);

							if (!selectedSgIds.has(bt.serviceGroupId)) {
								const sg = this.props.serviceGroups.serviceGroups.find((sg) => sg.id == bt.serviceGroupId);
								if (sg) {
									selectedServiceGroups.push(sg);
									selectedSgIds.add(bt.serviceGroupId);

									if (!selectedSgIds.has(sg.parentId)) {
										const parentSg = this.props.serviceGroups.serviceGroups.find((sgg) => sgg.id == sg.parentId);
										selectedServiceGroups.push(parentSg);
										selectedSgIds.add(sg.parentId);
									}
								}
							}
						}
					}
				});
			}

			const sgById = groupBy(selectedServiceGroups || [], 'id');
			const sgByParent = groupBy(selectedServiceGroups || [], 'parentId');
			const sgByCategory = groupBy(selectedServiceGroups || [], 'serviceCategoryId');
			const btByVariant = groupBy(selectedBt || [], 'variantParentId');
			const btById = groupBy(selectedBt || [], 'serviceGroupId');
			const byBySgByVp: { [key: string]: { [key: string]: IServicesList[] } } = {};
			const sgWithoutParentByCategory: { [key: string]: IServiceGroup[] } = {};
			Object.keys(sgByCategory).map((category) => {
				const orphans = sgByCategory[category]?.filter((sg) => sg.parentId == null);

				if (orphans?.length) {
					// Some categories are here only because child service groups have them and should be ignored
					sgWithoutParentByCategory[category] = orphans;
				}
			});
			Object.keys(btById).map((sgid) => (byBySgByVp[sgid] = groupBy(btById[sgid] || [], 'variantParentId')));

			this.setState({
				locations: locationNames as string[],
				groupedBt: {
					sgById,
					sgByParent,
					btByVariant,
					byBySgByVp,
					sgWithoutParentByCategory,
				},
			});
		}
	}

	render() {
		const { shopCard, t, discountStrategies, params, entireShopCard } = this.props;
		const discountGroups = discountStrategies.groupedDiscountStrategies || {};
		const discountGroupItem: IDiscountStrategy = discountGroups?.[params.promotionGroupId]?.[0];

		if (!discountGroupItem)
			return (
				<div className="viewPromotion container d-flex flex-row justify-content-center">
					<div className="col-lg-6 col-12">
						<ErrorSummary error={true} message={{}} />
					</div>
				</div>
			);

		const discountStr = discountGroupItem?.isDiscountPercentage
			? discountGroupItem?.discountValue + '%'
			: formatCurrency(shopCard?.currencyKey, discountGroupItem?.discountValue);

		const tagType = discountGroupItem?.isActive ? DiscountTagType.active : DiscountTagType.inactive;

		const promotionType = discountGroupItem?.type;

		const shopId = this.props.params.shopId;
		const groupId = this.props.params.promotionGroupId;

		const timezone = shopCard?.offices?.find((off) => off.id == discountGroupItem?.officeId)?.zoneInfo;

		return (
			<div className="viewPromotion container d-flex flex-row justify-content-center">
				<LoadingOverlayWrapper
					className="subsection-main col-lg-6 col-md-8 col-12"
					spinner={entireShopCard?.isFetching || discountStrategies?.isFetching}
				>
					<div className="headerContainer">
						<div className="left-content">
							<div className="d-flex flex-row justify-content-center align-items-center">
								<Link to={`/shop/${shopId}/edit/promo`} className="backButton">
									{renderIcon('arrow_left', 14, 14, 'desktop')}
									{renderIcon('arrow_left', 9, 9)}
								</Link>
								<h1>{discountGroupItem?.title}</h1>
							</div>
							{renderDiscountTag(t, tagType)}
						</div>
						<div className="right-content">
							<DropdownModal buttonComponent={renderIcon('moreVerticalGray', 24, 24)} stopPropagation={true}>
								<Link to={`/shop/${shopId}/edit/promo/${groupId}`}>{t('Shop_Promotions_Dropdown_Edit')}</Link>
								<Link to={`/shop/${shopId}/duplicate/promo/${groupId}`}>{t('Shop_Promotions_Dropdown_Duplicate')}</Link>
								<div onClick={() => this.setGroupActive(groupId, !discountGroupItem.isActive)}>
									{t('Shop_Promotions_Dropdown_' + (discountGroupItem.isActive ? 'Deactivate' : 'Activate'))}
								</div>
								<div onClick={() => this.deleteGroup(groupId)} className="red">
									{t('Shop_Promotions_Dropdown_Delete')}
								</div>
							</DropdownModal>
						</div>
					</div>
					<p className="headerDescription">
						{t(`Shop_Promotions_DiscountType_${discountGroupItem.type}`)}:{` ${discountStr} `}
						{discountGroupItem.productId
							? t('Shop_Promotions_DiscountOnSelectedServices')
							: t('Shop_Promotions_DiscountOnAllServices')}
					</p>

					{discountGroupItem?.description && (
						<>
							<h3 className="description">{t(`Shop_Promotions_New_BasicInfo_Description_Type_${promotionType}`)}</h3>
							<p className="description">{discountGroupItem?.description}</p>
						</>
					)}

					<div className="row">
						<div className="col-6">
							<h3>{t(`Shop_Promotions_New_Duration_Starts_Type_${promotionType}`)}</h3>
							<p>{formatDate(discountGroupItem.validFrom, timezone)}</p>
						</div>
						<div className="col-6">
							<h3>{t(`Shop_Promotions_New_Duration_Ends_Type_${promotionType}`)}</h3>
							<p>{formatDate(discountGroupItem.validTo, timezone)}</p>
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<h3>{t(`Shop_Promotions_New_DiscountValue_Title`)}</h3>
							<p>{discountStr}</p>
						</div>
						<div className="col-6">
							<h3>{t(`Shop_Promotions_Created`)}</h3>
							<p>{formatDateAndTime(discountGroupItem.addedDate)}</p>
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<h3>{t(`Shop_Promotions_New_Location_Title`)}</h3>
							<p>{this.state.locations?.join('; ')}</p>
						</div>
					</div>
					<LoadingOverlayWrapper
						className="row loadingOverlay"
						active={this.props.shopBookingTemplates?.isFetching || this.props.serviceGroups?.isFetching}
					>
						<div className="col-12">
							<h3>{t(`Shop_Promotions_AppliesTo`)}</h3>
							<div className="appliesToServices">
								{this.state.groupedBt?.sgWithoutParentByCategory &&
									// For each service category
									Object.keys(this.state.groupedBt?.sgWithoutParentByCategory)
										.filter((categoryId) => this.state.groupedBt.sgWithoutParentByCategory[categoryId]?.length)
										.map((categoryId) => (
											<React.Fragment key={`${categoryId} fragment`}>
												<h4 key={categoryId}>{t('DV_ServiceCategories_' + categoryId)}</h4>
												{
													// For each top level service group (the one with parentId == null)
													this.state.groupedBt.sgWithoutParentByCategory[categoryId].map((sg) => {
														return (
															<p key={sg.id}>
																<b>{sg.value}</b>
																{
																	// children of the service group can belong to other service categories!!
																	this.state.groupedBt.sgByParent[sg.id]
																		.filter((sgg) => !!this.state.groupedBt.byBySgByVp[sgg.id])
																		.map((sgg) =>
																			Object.keys(this.state.groupedBt.byBySgByVp[sgg.id]).length == 1
																				? this.state.groupedBt.byBySgByVp[sgg.id][
																						Object.keys(this.state.groupedBt.byBySgByVp[sgg.id])[0]
																				  ][0].name
																				: Object.keys(this.state.groupedBt.byBySgByVp[sgg.id])
																						.map(
																							(vp) =>
																								sgg.value + ' / ' + this.state.groupedBt.byBySgByVp[sgg.id][vp][0].name,
																						)
																						.join(', '),
																		)
																		.join(', ')
																}
															</p>
														);
													})
												}
											</React.Fragment>
										))}
							</div>
						</div>
					</LoadingOverlayWrapper>

					<ErrorSummary error={discountStrategies.error} message={discountStrategies.message} />
					<ErrorSummary error={entireShopCard.error} message={entireShopCard.message} />
				</LoadingOverlayWrapper>
			</div>
		);
	}
}

const ViewPromotion = connect(mapStateToProps, mapDispatchToProps)(ViewPromotionComponent);

export { ViewPromotion };
